import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function DatabaseHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const businesses = [{
    name: 'The daily grind cafe',
    contact: 'Sarah J. (Owner)',
    email: 'sarah@dailygrind.com',
    status: 'Sequenced'
  }, {
    name: 'Cityscape realty group',
    contact: 'Mike T. (Broker)',
    email: 'mike@cityscaperealty.com',
    status: 'Replied'
  }, {
    name: 'Precision auto repair',
    contact: 'David L. (Manager)',
    email: 'david@precisionauto.net',
    status: 'Sent'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-2318">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2319">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-2320">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-2321" /> All Features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-2322">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-2323">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-2324">
              The ultimate <br data-id="element-2325" />
              <span className="text-blue-600" data-id="element-2326">local business</span> <br data-id="element-2327" />
              database
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-2328">
              Access the most comprehensive local business listings. Get
              verified{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-2329">
                business owner emails
              </span>{' '}
              and launch{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-2330">
                built-in email sequences
              </span>{' '}
              directly from the platform.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-2331">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-2332">
                Search local businesses
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-2333">
              <div data-id="element-2334">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2335">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2336">
                  Local businesses
                </div>
              </div>
              <div data-id="element-2337">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2338">
                  Verified
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2339">
                  Owner emails
                </div>
              </div>
              <div data-id="element-2340">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2341">
                  Built-in
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2342">
                  Email sequencing
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-2343">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-2344">
              <div className="flex justify-between items-center mb-8" data-id="element-2345">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-2346">
                  Live Data Preview
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-2347">
                <table className="w-full text-sm text-left" data-id="element-2348">
                  <thead data-id="element-2349">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-2350">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-2351">Business</th>
                      <th className="pb-4 px-4 font-medium" data-id="element-2352">Employee</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-2353">Email</th>
                      <th className="pb-4 pl-4 font-medium hidden sm:table-cell" data-id="element-2354">
                        Outreach
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-2355">
                    {businesses.map((biz, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-2356">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl" data-id="element-2357">
                          {biz.name}
                        </td>
                        <td className="py-6 px-4 text-slate-600" data-id="element-2358">
                          <div className="whitespace-nowrap" data-id="element-2359">{biz.contact}</div>
                        </td>
                        <td className="py-6 pl-4 text-blue-600 truncate max-w-[120px] sm:max-w-none" data-id="element-2360">
                          {biz.email}
                        </td>
                        <td className="py-6 pl-4 hidden sm:table-cell rounded-r-xl" data-id="element-2361">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${biz.status === 'Replied' ? 'bg-green-100 text-green-800' : biz.status === 'Sequenced' ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-slate-800'}`} data-id="element-2362">
                            {biz.status}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-2363">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-2364">
                  Launch sequence
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}